var render = function render(_c,_vm){return _c('div',{staticClass:"ActionTooltip"},[(_vm.props.action.photo)?_c('figure',{staticClass:"image is-4by3",style:({ backgroundImage: `url(https://ddr90r1arm2wz.cloudfront.net/${_vm.props.action.photo})` })}):_vm._e(),_vm._v(" "),_c('div',{style:({ padding: '6px' })},[_c('strong',[_vm._v(_vm._s(_vm.props.action.name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }